<template>
    <div class="message"
         v-bind:class="{
            me: message.user.id === owner,
            'with-notification': !message.tracks.length
        }"
         v-view.once="touchMessage"
    >
        <div class="user-photo">
            <img :src="`https://ui-avatars.com/api/?name=${message.user.first_name}+${message.user.last_name}`"  alt="Imagen de usuario"/>
        </div>
        <div class="message-body">
            <div class="user-information">
                <span class="user-name">{{message.user.first_name}} {{message.user.last_name}}</span>
                <div class="message-time">
                    <time-ago :date="message.created_at" />
                </div>
            </div>
            <div class="message-text message-notification" v-if="message.notification === 1 || message.notification === '1' || message.notification === true">
                <i class="material-icons">notifications</i> <span v-html="message.text"></span>
            </div>
            <div class="message-text" v-else>
                <span v-html="message.text"></span>
            </div>
        </div>
    </div>
</template>
<script>

    import TimeAgo from './TimeAgo.vue';

    export default {
        components: {
            TimeAgo
        },
        props: ['message', 'owner'],
        methods: {
            touchMessage () {
                if (this.message.tracks && this.message.tracks.length === 0) {
                    axios({
                        url: `backend/api/messages/${this.message.id}`
                    });
                }
            }
        }
    }

</script>
